import useFetch from '../../../hooks/useFetch';
import rideApi from '../rideApi';

export default function useAccepterRideApi() {
    return useFetch(rideApi.accepter);
}
